import { getAllProducts } from "@framework/operations"

export function findProduct(id: string, products: any) {
  return products.find((product: any) => {
    if (product.id === id) {
      return product
    }
  })
}

// this function checks for review components without ids, and then
// replaces them with ids of the parent product
export async function hydrateCustomersAlsoBought(globalSettings: any) {
  const products = await (await getAllProducts())?.products
  const recommendedProducts: any[] = []
  globalSettings?.customersAlsoBoughtProducts.products.forEach(
    async (productId: any) => {
      let product = findProduct(productId, products)
      if (product) {
        recommendedProducts.push(product)
      }
    }
  )
  return recommendedProducts
}
